module.exports = __webpack_public_path__ + "static/media/PingFangHK Medium-01.2a1bce69.svg";